import React, { useState } from "react";
import FooterComponent from "../Footer/footer.component";
import HeaderComponent from "../Header/header.component";
import SpinnerComponent from "../../components/atoms/spinner/spinner.component";

const ProductsTemplate = ({ templateData, templateEvent }) => {
  const { inventoryItems, loading, error, product, activeTab } = templateData;
  const { handleProduct, handleTabClick, handleAddToCart } = templateEvent;

  console.log({ product });
  return (
    <>
      {/* <HeaderComponent /> */}
      <main className="main">
        <section id="ProdPage" className="ProdPage section">
          {loading ? (
            <div className="container mt-5" style={{ textAlign: "center" }}>
              <SpinnerComponent />
            </div>
          ) : (
            <>
              <div className="container">
                <div className="ClsDescrip">
                  {product?.result?.length > 0 ? (
                    product.result.map((item, index) => (
                      // Your existing product mapping code here
                      <div key={index} className="product-item">
                        {/* Product details */}
                      </div>
                    ))
                  ) : (
                    <div
                      className="no-products-message"
                      style={{
                        textAlign: "center",
                        padding: "40px 20px",
                        margin: "20px 0",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        border: "1px solid #e9ecef",
                      }}
                    >
                      <h3
                        style={{
                          color: "#6c757d",
                          marginBottom: "15px",
                        }}
                      >
                        No Matching Products Found
                      </h3>
                      <p
                        style={{
                          color: "#6c757d",
                          marginBottom: "20px",
                        }}
                      >
                        We couldn't find any products matching your search.
                      </p>
                    </div>
                  )}
                  {/* <!-- Block 1 --> */}
                  <div className="ClsBlock1 Attriblock">
                    {product?.result?.map(
                      (item, index) => (
                        console.log({ item }),
                        (
                          <>
                            <div className="row" key={index}>
                              <div
                                className="col-lg-2 LBlock"
                                data-aos="fade-up"
                                data-aos-delay="100"
                              >
                                <div className="ProdImage">
                                  <img
                                    src={item.image}
                                    alt={item.description || "Product Image"}
                                  />
                                </div>
                              </div>

                              <div
                                className="col-lg-6 RBlock d-flex flex-column"
                                data-aos="fade-up"
                                data-aos-delay="200"
                              >
                                <div className="ClsCTable">
                                  <div className="PTabular no-scroll">
                                    <div className="row">
                                      <table>
                                        <tr>
                                          <td className="ptitle">
                                            {item.part_number}
                                          </td>
                                          <td></td>
                                        </tr>
                                        <tr>
                                          <td className="pcate">Part Number</td>
                                          <td className="pcatdet">
                                            {item.part_number}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="pcate">
                                            Manufacturer
                                          </td>
                                          <td className="pcatdet">
                                            {item.make}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="pcate">
                                            Manufacturer Eaton
                                          </td>
                                          <td className="pcatdet">
                                            <a href="#">Electronics Division</a>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td className="pcate">Description</td>
                                          <td className="pcatdet">
                                            {item.description}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td className="pcate">
                                            Manufacture Standard Lead Time
                                          </td>
                                          <td className="pcatdet">
                                            {item.lead_time}
                                          </td>
                                        </tr>
                                        {/* <tr>
                                    <td className="pcate">
                                      Detailed Description
                                    </td>
                                    <td className="pcatdet">
                                      {item.detailed_description}
                                    </td>
                                  </tr> */}
                                        <tr>
                                          <td className="pcate">Datasheet</td>
                                          <td className="pcatdet">
                                            <img
                                              src="assets/img/pdf-icon.png"
                                              alt="PDF Icon"
                                            />{" "}
                                            <a href={item.datasheet_url}>
                                              Datasheet
                                            </a>
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="col-lg-4 RBlock d-flex flex-column"
                                data-aos="fade-up"
                                data-aos-delay="200"
                              >
                                <div className="CSummaryTop">
                                  <table className="ClsCSTable">
                                    <tr className="ClsCtextblue">
                                      <td>In stock</td>
                                      <td className="clsval">
                                        {item.available_qty}
                                      </td>
                                    </tr>
                                    <tr className="ClsCtext">
                                      <td>
                                        <div className="quanbox">
                                          <label className="qbig">
                                            Quantity
                                          </label>
                                          <input
                                            type="number"
                                            // value={item.quantity}
                                            className="pquan"
                                            ref={(el) => (item.qtyRef = el)}
                                          />
                                          <label className="qsmall">
                                            1 Quantity: ₹ {item.unit_price}
                                          </label>
                                        </div>
                                      </td>
                                      <td></td>
                                    </tr>
                                    <tr className="ClsCTotal ClsCtextblue">
                                      <td>Price</td>
                                      <td className="clsval">
                                        {item.price && item.price[0]
                                          ? `₹ ${Number(
                                              item.price[0].price
                                            ).toFixed(2)}`
                                          : "N/A"}
                                      </td>
                                    </tr>
                                  </table>
                                  <div className="ClsTCbtn">
                                    <a href="#" className="clsAddlist">
                                      Add to List
                                    </a>
                                    <a
                                      href="#"
                                      className="clsAddcart"
                                      onClick={() => {
                                        const enteredQty =
                                          parseInt(item.qtyRef?.value) || 0;
                                        handleAddToCart({
                                          ...item,
                                          required_qty: enteredQty,
                                        });
                                      }}
                                    >
                                      Add to Cart
                                    </a>
                                  </div>
                                </div>
                                <div className="CSummaryBtm">
                                  <table className="ClsCSTable">
                                    <tr>
                                      <th>Quantity</th>
                                      <th>Unit Price</th>
                                      <th>Ext. Price</th>
                                    </tr>
                                    {item.price && Array.isArray(item.price) ? (
                                      item.price.map((qty, idx) => (
                                        <tr key={idx}>
                                          <td>{qty.slab || 1}+</td>
                                          <td>
                                            ₹{" "}
                                            {qty.price
                                              ? Number(qty.price).toFixed(2)
                                              : "N/A"}
                                          </td>
                                          <td>
                                            ₹{" "}
                                            {qty.price && qty.slab
                                              ? (qty.price * qty.slab).toFixed(
                                                  2
                                                )
                                              : "N/A"}
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="3">
                                          Pricing not available
                                        </td>
                                      </tr>
                                    )}
                                  </table>
                                </div>
                              </div>
                            </div>

                            <div className="ClsBlock1 clsSimilarTabs">
                              <div className="row">
                                <div
                                  className="col-lg-12 LBlock"
                                  data-aos="fade-up"
                                  data-aos-delay="100"
                                >
                                  <div className="tabs-7">
                                    <ul className="tabs">
                                      <li
                                        className={
                                          activeTab === "Pattri" ? "active" : ""
                                        }
                                      >
                                        <div
                                          onClick={() =>
                                            handleTabClick("Pattri")
                                          }
                                        >
                                          Product Attributes
                                        </div>
                                      </li>
                                      <li
                                        className={
                                          activeTab === "DocMed" ? "active" : ""
                                        }
                                      >
                                        <div
                                          onClick={() =>
                                            handleTabClick("DocMed")
                                          }
                                        >
                                          Documents & Media
                                        </div>
                                      </li>
                                      <li
                                        className={
                                          activeTab === "Envi" ? "active" : ""
                                        }
                                      >
                                        <div
                                          onClick={() => handleTabClick("Envi")}
                                        >
                                          Environmental & Export Classifications
                                        </div>
                                      </li>
                                      <li
                                        className={
                                          activeTab === "AddRe" ? "active" : ""
                                        }
                                      >
                                        <div
                                          onClick={() =>
                                            handleTabClick("AddRe")
                                          }
                                        >
                                          Additional Resources
                                        </div>
                                      </li>
                                    </ul>
                                    <section className="tab_content_wrapper">
                                      <article
                                        className="tab_content"
                                        id="Pattri"
                                        style={{
                                          display:
                                            activeTab === "Pattri"
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        <div className="PTabular">
                                          <table className="PAttriTab">
                                            <tr>
                                              <th>Type</th>
                                              <th>Description</th>
                                              <th className="clsPatcheck">
                                                <span>
                                                  Select All
                                                  <input
                                                    type="checkbox"
                                                    name="select"
                                                    className="Bcheck"
                                                  />
                                                </span>
                                              </th>
                                            </tr>
                                            <tr>
                                              <td>Category</td>
                                              <td>{item?.category_name}</td>
                                              <td className="align-center">
                                                <input
                                                  type="checkbox"
                                                  name="select"
                                                  className="Bcheck"
                                                />
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Manufacturer</td>
                                              <td>{item?.make}</td>
                                              <td className="align-left">
                                                <input
                                                  type="checkbox"
                                                  name="select"
                                                  className="Bcheck"
                                                />
                                              </td>
                                            </tr>
                                            {item.specifications?.map(
                                              (spec, idx) => (
                                                <tr key={idx}>
                                                  <td>
                                                    {spec.specification_name}
                                                  </td>
                                                  <td>
                                                    {spec.specification_value}
                                                  </td>
                                                  <td className="align-left">
                                                    <input
                                                      type="checkbox"
                                                      name="select"
                                                      className="Bcheck"
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </table>
                                        </div>
                                        <div className="clsBluebtn">
                                          <a className="Vsimilar">
                                            View Similar
                                          </a>
                                        </div>
                                      </article>
                                      <article
                                        className="tab_content"
                                        id="DocMed"
                                        style={{
                                          display:
                                            activeTab === "DocMed"
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        <p>
                                          Copyright eurus supplex undae fulgura
                                          congestaque locis. Gravitate ante
                                          nabataeaque sua naturae satus ad.{" "}
                                          <a href="#tab2">Copyright</a> madescit
                                          pugnabant effervescere abscidit altae.
                                          Parte norant principio vultus
                                          reparabat omni rapidisque.
                                        </p>
                                      </article>
                                      <article
                                        className="tab_content"
                                        id="Envi"
                                        style={{
                                          display:
                                            activeTab === "Envi"
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        <p>
                                          Copyright eurus supplex undae fulgura
                                          congestaque locis. Gravitate ante
                                          nabataeaque sua naturae satus ad.{" "}
                                          <a href="#tab2">Copyright</a> madescit
                                          pugnabant effervescere abscidit altae.
                                          Parte norant principio vultus
                                          reparabat omni rapidisque.
                                        </p>
                                      </article>
                                      <article
                                        className="tab_content"
                                        id="AddRe"
                                        style={{
                                          display:
                                            activeTab === "AddRe"
                                              ? "block"
                                              : "none",
                                        }}
                                      >
                                        <p>
                                          Copyright flamma erectos tempora
                                          sorbentur illas foret ambitae. Sata
                                          locavit triones. Terrarum tuti diversa
                                          formas diffundi prima quod regio
                                          premuntur. Ipsa pluviaque toto valles
                                          conversa quinta.
                                        </p>
                                      </article>
                                    </section>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )
                      )
                    )}
                  </div>
                  {/* <!-- Block 2 --> */}
                </div>
              </div>

              {/* </div> */}
              {/* <!-- Accordion --> */}
              <div className="container ClsFaqBlock">
                <div className="ClsFAQ">
                  {/* <!-- Title --> */}
                  <div className="ClsTitle d-flex align-items-center">
                    <div className="container position-relative">
                      <div className="row">
                        <div className="title col-lg-9">
                          <h3>Product Questions and Answers</h3>
                        </div>
                        <div className="filter col-lg-3">
                          <a href="#" className="clschecktn AddFAQ">
                            Ask a Product Question
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Title --> */}
                  <div className="ClsBlock1">
                    <div className="row">
                      <ul>
                        <li>
                          <button className="akccordion">
                            Do you have a return or refund policy?
                          </button>
                          <div className="panel">
                            <p>
                              Lorem ipsum dolor sit amet, consectetur
                              adipisicing elit, sed do eiusmod tempor incididunt
                              ut labore et dolore magna aliqua. Ut enim ad minim
                              veniam, quis nostrud exercitation ullamco laboris
                              nisi ut aliquip ex ea commodo consequat.
                            </p>
                          </div>
                        </li>
                        <li>
                          <button className="akccordion">
                            Do you have a return or refund policy?
                          </button>
                          <div className="panel">
                            <p>
                              Lorem ipsum dolor sit amet, consectetur
                              adipisicing elit, sed do eiusmod tempor incididunt
                              ut labore et dolore magna aliqua. Ut enim ad minim
                              veniam, quis nostrud exercitation ullamco laboris
                              nisi ut aliquip ex ea commodo consequat.
                            </p>
                          </div>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <button className="akccordion">
                            Do you have a return or refund policy?
                          </button>
                          <div className="panel">
                            <p>
                              Lorem ipsum dolor sit amet, consectetur
                              adipisicing elit, sed do eiusmod tempor incididunt
                              ut labore et dolore magna aliqua. Ut enim ad minim
                              veniam, quis nostrud exercitation ullamco laboris
                              nisi ut aliquip ex ea commodo consequat.
                            </p>
                          </div>
                        </li>
                        <li>
                          <button className="akccordion">
                            Do you have a return or refund policy?
                          </button>
                          <div className="panel">
                            <p>
                              Lorem ipsum dolor sit amet, consectetur
                              adipisicing elit, sed do eiusmod tempor incididunt
                              ut labore et dolore magna aliqua. Ut enim ad minim
                              veniam, quis nostrud exercitation ullamco laboris
                              nisi ut aliquip ex ea commodo consequat.
                            </p>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- Accordion --> */}
              {/* <!-- Similar Products --> */}
              <div className="container ClsSPBlock">
                <div className="ClsSimilar">
                  {/* <!-- Title --> */}
                  <div className="ClsTitle d-flex align-items-center">
                    <div className="container position-relative">
                      <div className="row">
                        <div className="title col-lg-9">
                          <h3>Similar Products</h3>
                        </div>
                        <div className="simfilter col-lg-3">
                          <a href="#" className="SeAll">
                            See All
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Title --> */}
                  <div className="ClsSimilarBlock">
                    <div className="row">
                      <div
                        className="col-lg-4 LBlock"
                        data-aos="fade-up"
                        data-aos-delay="100"
                      >
                        <div className="ClsProd1 col-lg-12">
                          <div className="row">
                            <div className="ProdImage col-lg-4">
                              <img
                                src="assets/img/cart-prod-image.png"
                                alt="Product Icon"
                              />
                            </div>
                            <div className="ClsPrdes col-lg-8">
                              <ul>
                                <li className="Pdtitle">HSHO612-3R8805-R</li>
                                <li className="Pddes">
                                  CAP LITH HYBRID TH 3.8V 3F
                                </li>
                                <li className="Pdcate">
                                  Eaton - Electronics Division
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="clsSimbtn">
                            <a href="#" className="clsSbtn clsSimPrice">
                              ₹ 636.6688
                            </a>
                            <a href="#" className="clsSbtn clsSimDetails">
                              Details
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-lg-4 LBlock"
                        data-aos="fade-up"
                        data-aos-delay="100"
                      >
                        <div className="ClsProd1 col-lg-12">
                          <div className="row">
                            <div className="ProdImage col-lg-4">
                              <img
                                src="assets/img/cart-prod-image.png"
                                alt="Product Icon"
                              />
                            </div>
                            <div className="ClsPrdes col-lg-8">
                              <ul>
                                <li className="Pdtitle">HSHO612-3R8805-R</li>
                                <li className="Pddes">
                                  CAP LITH HYBRID TH 3.8V 3F
                                </li>
                                <li className="Pdcate">
                                  Eaton - Electronics Division
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="clsSimbtn">
                            <a href="#" className="clsSbtn clsSimPrice">
                              ₹ 636.6688
                            </a>
                            <a href="#" className="clsSbtn clsSimDetails">
                              Details
                            </a>
                          </div>
                        </div>
                      </div>
                      <div
                        className="col-lg-4 LBlock"
                        data-aos="fade-up"
                        data-aos-delay="100"
                      >
                        <div className="ClsProd1 col-lg-12">
                          <div className="row">
                            <div className="ProdImage col-lg-4">
                              <img
                                src="assets/img/cart-prod-image.png"
                                alt="Product Icon"
                              />
                            </div>
                            <div className="ClsPrdes col-lg-8">
                              <ul>
                                <li className="Pdtitle">HSHO612-3R8805-R</li>
                                <li className="Pddes">
                                  CAP LITH HYBRID TH 3.8V 3F
                                </li>
                                <li className="Pdcate">
                                  Eaton - Electronics Division
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="clsSimbtn">
                            <a href="#" className="clsSbtn clsSimPrice">
                              ₹ 636.6688
                            </a>
                            <a href="#" className="clsSbtn clsSimDetails">
                              Details
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </section>
      </main>
      {/* <FooterComponent /> */}
    </>
  );
};

export default ProductsTemplate;
